import angular from 'angular';

import { inputNumberWithUnit } from './condition-directives/input-number-with-unit.directive';
import { rating } from './condition-directives/rating.directive';
import { selectGroupThenHierarchical } from './condition-directives/select-group-then-hierarchical.directive';
import { selectGroupThenMultipleHierarchical } from './condition-directives/select-group-then-multiple-hierarchical.directive';
import { selectHierarchical } from './condition-directives/select-hierarchical.directive';
import { selectMultipleHierarchical } from './condition-directives/select-multiple-hierarchical.directive';
import { selectMultiple } from './condition-directives/select-multiple.directive';
import { selectSingle } from './condition-directives/select-single.directive';
import { selectSiteThenPublication } from './condition-directives/select-site-then-publication.directive';
import { setOfKeywords } from './condition-directives/set-of-keywords.directive';
import { DropdownItemsService } from './dropdown-items.service';
import { messageCondition } from './message-condition/message-condition.directive';
import { MessageConditionService } from './message-condition/message-condition.service';
import { ParametersService } from './parameters.service';
import { autoContentTooltip } from './tooltip/auto-content-tooltip.directive';

angular
  .module('parameters.shared', [])
  .factory('ParametersFactory', ParametersService.ParametersFactory)
  .factory('DropdownItemsFactory', DropdownItemsService.DropdownItemsFactory)
  .factory('MessageConditionFactory', MessageConditionService.MessageConditionFactory)
  .directive('selectMultiple', selectMultiple)
  .directive('selectSingle', selectSingle)
  .directive('selectMultipleHierarchical', selectMultipleHierarchical)
  .directive('selectHierarchical', selectHierarchical)
  .directive('inputNumberWithUnit', inputNumberWithUnit)
  .directive('setOfKeywords', setOfKeywords)
  .directive('selectGroupThenMultipleHierarchical', selectGroupThenMultipleHierarchical)
  .directive('selectGroupThenHierarchical', selectGroupThenHierarchical)
  .directive('selectSiteThenPublication', selectSiteThenPublication)
  .directive('messageCondition', messageCondition)
  .directive('autoContentTooltip', autoContentTooltip)
  .directive('rating', rating)
  ;
